/**
 * openExternal — abre URLs externas de forma compatível com web e Capacitor nativo.
 *
 * Em WebView nativa (iOS/Android), `window.open(url, "_blank")` é silenciosamente
 * ignorado. Este wrapper usa o plugin @capacitor/browser para abrir no Safari
 * View Controller (iOS) / Custom Tabs (Android) quando rodando como app nativo,
 * e cai pra `window.open` no browser.
 */

type CapacitorGlobal = {
  isNativePlatform?: () => boolean;
};

declare global {
  interface Window {
    Capacitor?: CapacitorGlobal;
  }
}

function isNative(): boolean {
  try {
    return typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
}

export async function openExternal(
  url: string,
  target: "_blank" | "_self" = "_blank"
): Promise<void> {
  if (!url) return;

  if (isNative()) {
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url });
      return;
    } catch (err) {
      console.warn("[openExternal] Capacitor Browser failed, falling back", err);
    }
  }

  try {
    window.open(url, target, "noopener,noreferrer");
  } catch (err) {
    console.warn("[openExternal] window.open failed", err);
  }
}

export default openExternal;
